import Bottleneck from 'bottleneck';
const bns = {};
export const bottleneck = async (handle, minTime, f, concurrent) => new Promise((res, rej) => {
    if (!bns[handle]) {
        bns[handle] = new Bottleneck({
            maxConcurrent: concurrent,
            minTime: minTime,
        });
    }
    bns[handle].schedule(f).then(res).catch(rej);
});
export const sortBy = (...compareFunctions) => (a, b) => {
    if (compareFunctions.length === 0) {
        return 0;
    }
    for (let i = 0; i < compareFunctions.length; i++) {
        const result = compareFunctions[i](a, b);
        if (result !== 0) {
            return result;
        }
    }
    return 0;
};
export const sortByWithExtraDiscriminator = (...compareFunctions) => (a, b, c) => {
    if (compareFunctions.length === 0) {
        return 0;
    }
    for (let i = 0; i < compareFunctions.length; i++) {
        const result = compareFunctions[i](a, b, c);
        if (result !== 0) {
            return result;
        }
    }
    return 0;
};
export const sortBySameCategoryDateDescFirst = (a, b, voucherBeingAppended) => {
    // If same category as voucherBeingAppended, sort by createdAt descending
    const aSameCategory = a.category === voucherBeingAppended.category;
    const bSameCategory = b.category === voucherBeingAppended.category;
    if (aSameCategory && bSameCategory) {
        return b.rawDate - a.rawDate;
    }
    if (aSameCategory) {
        return -1;
    }
    if (bSameCategory) {
        return 1;
    }
    return 0;
};
export const clone = (o) => JSON.parse(JSON.stringify(o));
export const luhnChecksum = (code) => {
    const len = code.length;
    const parity = len % 2;
    let sum = 0;
    for (let i = len - 1; i >= 0; i--) {
        let d = parseInt(code.charAt(i));
        if (i % 2 == parity) {
            d *= 2;
        }
        if (d > 9) {
            d -= 9;
        }
        sum += d;
    }
    return sum % 10;
};
export const encodeFiPaymentId = (partcode) => {
    const pcode = partcode.toString();
    let checksum = luhnChecksum(pcode + '0');
    checksum = checksum == 0 ? 0 : 10 - checksum;
    let digit = pcode + checksum;
    while (digit.length < 15) {
        digit = '0' + digit;
    }
    return digit;
};
export const decodeFiPaymentId = (s) => {
    const n = parseInt(s.slice(0, -1));
    if (s.slice(-1) !== encodeFiPaymentId(n).slice(-1)) {
        throw new Error('Error in payment ID');
    }
    return n;
};
export const parseDate = (date, config) => {
    if (config?.startOfMonth) {
        return new Date(date.slice(0, 7) + '-01').getTime();
    }
    else {
        return new Date(date.slice(0, 10)).getTime();
    }
};
export const toISODate = (d) => {
    if (typeof d === 'string') {
        return d;
    }
    return new Date(d).toISOString();
};
export const addDatesToCaseVoucher = (cv) => {
    let voucher = cv;
    voucher.rawDate = voucher.rawDate ?? new Date(voucher.date).getTime();
    voucher.parsedDate = voucher.parsedDate ?? parseDate(toISODate(voucher.date));
    voucher.parsedInterestStartDate =
        voucher.parsedInterestStartDate ??
            (voucher.interestStartDate
                ? parseDate(toISODate(voucher.interestStartDate))
                : null);
    voucher.parsedInterestEndDate =
        voucher.parsedInterestEndDate ??
            (voucher.interestEndDate
                ? parseDate(toISODate(voucher.interestEndDate))
                : null);
    return voucher;
};
//# sourceMappingURL=utils.js.map